import { useEffect, useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { historyKeys } from '../../api/query-keys'
import { auth_listener } from '../../api/auth-listener'
import { useMe } from '../../hooks/useMe'
import { useScrollPositionManager } from '../../hooks/scroll-position'

/** Account-owned state outlives routes, but never the authenticated account. */
const HistorySessionGuard = () => {
  const account_id = useMe()?.user_id
  const queryClient = useQueryClient()
  const positions = useScrollPositionManager()
  const previous_account = useRef(account_id)

  useEffect(() => {
    const previous = previous_account.current
    previous_account.current = account_id
    if (!previous || previous === account_id) return
    // The next account may already have started its Suspense read during render.
    // Remove the outgoing account only, preserving the new request's ownership.
    queryClient.removeQueries({queryKey: historyKeys.account(previous)})
    queryClient.removeQueries({queryKey: ['history-album-photos', previous]})
    positions.clearPrefix(`history:${previous}:`)
    positions.clearPrefix(`history:viewer:${previous}:`)
  }, [account_id, queryClient, positions.clearPrefix])

  useEffect(() => {
    const clear = () => {
      queryClient.removeQueries({queryKey: historyKeys.all})
      queryClient.removeQueries({queryKey: ['history-album-photos']})
      positions.clearPrefix('history:')
    }
    const unsubscribe = auth_listener.listen(state => {
      if (state !== 'authenticated') clear()
    })
    return () => { unsubscribe(); clear() }
  }, [queryClient, positions.clearPrefix])
  return null
}
export default HistorySessionGuard
